import React, { AriaRole } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconCopyOutline } from '@saucelabs/ds-icons';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import { GlobalState } from '../../../reducers';
import { TOOLBAR_TRACKING_NAMES, trackEvent } from '../../../tracking';
import { CONFIGURATION_DEVICE_TYPES } from '../../../constants';
import { MOBILE_PASTE_CONTENT_MODAL_KEY } from '../../../components/MobileManualSession/PasteContentModal';
import {
  selectors as liveSessionManagerSelectors,
  VIRTUAL_SESSION_CLIPBOARD_MODAL_KEY,
} from '../../liveSessionManager';
import selectors from '../selectors';
import GenericButton from './GenericButton';

// TODO: remove when liveSessionManager selectors are properly typed
type VirtualSession = {
  isChannelReconnecting: boolean;
  screenshotRetrievalInProgress: boolean;
}

const CopyToClipboardButton: React.FC<{ role?: AriaRole }> = ({ role }) => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const {
    deviceToolsDisabled,
    deviceType,
    testType,
  } = useSelector(selectors.toolbarButtonSelector);
  const {
    isChannelReconnecting,
    screenshotRetrievalInProgress,
  } = useSelector<GlobalState, VirtualSession>(liveSessionManagerSelectors.virtualSessionSelector);

  const isMobileRealSession = deviceType === CONFIGURATION_DEVICE_TYPES.REAL_DEVICE;
  const isDisabled = isMobileRealSession ?
    deviceToolsDisabled :
    isChannelReconnecting || screenshotRetrievalInProgress;

  const showClipboardModal = () => {
    void dispatch(modalActions.showModal(isMobileRealSession ?
      MOBILE_PASTE_CONTENT_MODAL_KEY :
      VIRTUAL_SESSION_CLIPBOARD_MODAL_KEY,
    ));

    trackEvent(TOOLBAR_TRACKING_NAMES.CLIPBOARD, { deviceType, testType });
  };

  return (
    <GenericButton
      dataQa="live-session-toolbar-button-copy-to-clipboard"
      disabled={isDisabled}
      icon={IconCopyOutline}
      label="Copy to Clipboard"
      onPress={showClipboardModal}
      role={role}
    />
  );
};

CopyToClipboardButton.displayName = 'CopyToClipboardButton';

export default CopyToClipboardButton;
